import { Component } from 'react';
import PropTypes from 'prop-types';

import PlaceholderCard from './PlaceholderCard';
import Card from './Card';

import autoServiceApi from '../../../../utils/autoServiceApi';

export default class ServicesCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      services: [],
      isFetching: true,
    };

    this.carousel = null;

    this.initCarousel = this.initCarousel.bind(this);
    this.fetchServices = this.fetchServices.bind(this);
    this.filteredServicesList = this.filteredServicesList.bind(this);
    this.matchHeight = this.matchHeight.bind(this);
  }

  componentDidMount() {
    this.initCarousel();
    this.fetchServices();
  }

  componentDidUpdate() {
    this.initCarousel();
    this.matchHeight();
  }

  filteredServicesList(servicesList) {
    const { currentServiceSlug } = this.props;
    const limitServicesList = servicesList.slice(0, 8);

    if (!currentServiceSlug) return limitServicesList;

    const currentServiceIsPresent = servicesList.find(
      services => services.slug === currentServiceSlug,
    );

    if (currentServiceIsPresent) {
      const filteredServicesList = servicesList.filter(
        services => services.slug !== currentServiceSlug,
      );

      return filteredServicesList;
    }

    return limitServicesList;
  }

  async fetchServices() {
    const requestParams = [
      { 'q[active_eq]': true },
      { per_page: 9 },
      { page: 1 },
      { sort: 'ordination,id' },
    ];
    const result = await autoServiceApi.getServices(requestParams);

    const servicesList = result ? result.entries : this.state.services;
    const filteredServicesList = this.filteredServicesList(servicesList);

    this.setState(() => ({
      services: filteredServicesList,
      isFetching: false,
    }));
  }

  initCarousel() {
    if (this.carousel) this.carousel.destroy();

    const carousel = window.makeCarousel(this.carouselRef, {
      perPage: 4,
      perMove: 1,
      arrows: false,
      pagination: false,
      lazyLoad: 'nearby',
      preloadPages: 0,
      gap: 24,
      breakpoints: {
        768: {
          perPage: 1,
          perMove: 1,
          fixedWidth: 255,
        },
        990: {
          perPage: 2,
          perMove: 1,
          gap: 32,
          padding: 20,
          drag: true,
        },
        1200: {
          perPage: 4,
          perMove: 1,
        },
      },
    });

    this.carousel = carousel;

    return carousel;
  }

  matchHeight() {
    if (!window.matchHeight) return;

    window.matchHeight.match('.services__carousel-wrapper');
  }

  render() {
    const { services, isFetching } = this.state;
    const { cardLink, cardPlaceholderImage } = this.props;

    return (
      <div
        className="services__carousel splide"
        data-is-fetching={isFetching}
        ref={node => {
          this.carouselRef = node;
        }}
      >
        <div className="splide__track container">
          <div className="splide__list services__carousel-items-wrapper">
            {isFetching &&
              services.length === 0 &&
              [1, 2, 3, 4, 5, 6, 7, 8].map(item => (
                <div
                  className="services__carousel-placeholder__item carousel__item splide__slide"
                  key={item}
                >
                  <PlaceholderCard />
                </div>
              ))}
            {!isFetching &&
              services.length > 0 &&
              services.map(service => (
                <div
                  className="services__carousel-item splide__slide"
                  key={service.slug}
                >
                  <Card
                    itemImage={service.item_image}
                    title={service.title}
                    slogan={service.slogan}
                    summary={service.summary}
                    baseLink={cardLink}
                    slug={service.slug}
                    placeholderImage={cardPlaceholderImage}
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
    );
  }
}

ServicesCarousel.defaultProps = {
  cardLink: '/servicos',
  currentServiceSlug: '',
  cardPlaceholderImage: '',
};

ServicesCarousel.propTypes = {
  cardLink: PropTypes.string,
  currentServiceSlug: PropTypes.string,
  cardPlaceholderImage: PropTypes.string,
};
